/**
 * Create Your Custom Artwork — format/size cascade for Kalles linked options.
 * - Formats with any available variants stay selectable (no sold-out strike).
 * - Sizes not belonging to the current format are hidden.
 * - Clicking a format picks the first available size for that format.
 * - Gallery: hide media used as Artwork Format variant images (auto via featured_media).
 */
(function () {
  'use strict';

  var HANDLE = 'create-your-custom-artwork';
  var ROOT_ATTR = 'data-ans-ctor-variants';
  var HIDE_MEDIA_SCRIPT_ID = 'ans-ctor-hide-media-ids';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function findRoot() {
    var nodes = document.querySelectorAll('[data-product-featured]');
    for (var i = 0; i < nodes.length; i++) {
      var raw = nodes[i].getAttribute('data-product-featured') || '';
      try {
        var cfg = JSON.parse(raw);
        if (cfg && cfg.productHandle === HANDLE) return nodes[i];
      } catch (e) {
        if (raw.indexOf(HANDLE) !== -1) return nodes[i];
      }
    }
    return null;
  }

  function getForm(root) {
    try {
      var cfg = JSON.parse(root.getAttribute('data-product-featured') || '{}');
      if (cfg.formID) {
        var el = document.querySelector(cfg.formID);
        if (el) return el;
      }
    } catch (e) {}
    return root.querySelector('form[data-type="add-to-cart-form"], form.t4s-form__product');
  }

  function optionWrap(form, id) {
    return form.querySelector('[data-swatch-option][data-id="' + id + '"]');
  }

  function buildMaps(variants) {
    var byFormat = {};
    var i;
    for (i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (!v || !v.available) continue;
      var f = String(v.option1 || '');
      if (!byFormat[f]) byFormat[f] = [];
      byFormat[f].push({
        size: String(v.option2 || ''),
        depth: String(v.option3 || ''),
        id: String(v.id),
      });
    }
    return byFormat;
  }

  function syncRadios(form, format, size, depth) {
    var pairs = [
      { wrapId: '0', value: format },
      { wrapId: '1', value: size },
      { wrapId: '2', value: depth },
    ];
    pairs.forEach(function (p) {
      if (!p.value) return;
      var wrap = optionWrap(form, p.wrapId);
      if (!wrap) return;

      var input = null;
      var inputs = wrap.querySelectorAll('input.t4s-swatch-input');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value === p.value) {
          input = inputs[i];
          break;
        }
      }
      if (!input) return;

      input.checked = true;
      var label = null;
      var labels = wrap.querySelectorAll('label[data-swatch-item]');
      for (var j = 0; j < labels.length; j++) {
        if (labels[j].getAttribute('data-value') === p.value) {
          label = labels[j];
          break;
        }
      }
      if (label) {
        for (var k = 0; k < labels.length; k++) {
          labels[k].classList.toggle('is--selected', labels[k] === label);
        }
        var cur = wrap.querySelector('[data-current-value]');
        if (cur) cur.textContent = p.value;
      }
    });
  }

  function setVariantSelect(form, variantId) {
    var select = form.querySelector('select[name="id"], select.t4s-product__select');
    if (!select || !variantId) return;
    select.value = variantId;
    select.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
  }

  function refreshUi(form, byFormat) {
    var formatWrap = optionWrap(form, '0');
    var sizeWrap = optionWrap(form, '1');
    if (!formatWrap || !sizeWrap) return;

    var selectedFormatInput = formatWrap.querySelector('input.t4s-swatch-input:checked');
    var format = selectedFormatInput ? selectedFormatInput.value : '';
    var sizes = byFormat[format] || [];
    var sizeSet = {};
    sizes.forEach(function (row) {
      sizeSet[row.size] = true;
    });

    // Formats: never show sold-out strike if that format has stocked variants
    var formatLabels = formatWrap.querySelectorAll('label[data-swatch-item]');
    for (var i = 0; i < formatLabels.length; i++) {
      var fl = formatLabels[i];
      var fv = fl.getAttribute('data-value') || '';
      if (byFormat[fv] && byFormat[fv].length) {
        fl.classList.remove('is--soldout', 'is--unavailable');
      }
    }

    // Sizes: show only those that exist for current format
    var sizeLabels = sizeWrap.querySelectorAll('label[data-swatch-item]');
    var sizeInputs = sizeWrap.querySelectorAll('input.t4s-swatch-input');
    for (var s = 0; s < sizeLabels.length; s++) {
      var sl = sizeLabels[s];
      var sv = sl.getAttribute('data-value') || '';
      var show = !!sizeSet[sv];
      sl.classList.toggle('ans-ctor-size--hidden', !show);
      if (show) {
        sl.classList.remove('is--soldout', 'is--unavailable');
      }
    }
    for (var n = 0; n < sizeInputs.length; n++) {
      var inp = sizeInputs[n];
      inp.classList.toggle('ans-ctor-size--hidden', !sizeSet[inp.value]);
    }
  }

  function pickVariantForFormat(byFormat, format, preferredSize) {
    var rows = byFormat[format] || [];
    if (!rows.length) return null;
    if (preferredSize) {
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].size === preferredSize) return rows[i];
      }
    }
    return rows[0];
  }

  function fileKey(url) {
    if (!url) return '';
    try {
      return String(url).split('?')[0].split('/').pop().toLowerCase();
    } catch (e) {
      return '';
    }
  }

  /** Unique featured_media IDs from Liquid (preferred) + product.js featured_image files. */
  function collectHideTargets(product) {
    var ids = {};
    var files = {};
    var el = document.getElementById(HIDE_MEDIA_SCRIPT_ID);
    if (el) {
      try {
        var list = JSON.parse(el.textContent || '[]');
        for (var i = 0; i < list.length; i++) {
          if (list[i] != null && list[i] !== '') ids[String(list[i])] = true;
        }
      } catch (e) {}
    }
    var variants = (product && product.variants) || [];
    for (var v = 0; v < variants.length; v++) {
      var fi = variants[v] && variants[v].featured_image;
      if (!fi) continue;
      if (fi.id != null) ids[String(fi.id)] = true;
      var fk = fileKey(fi.src);
      if (fk) files[fk] = true;
    }
    return { ids: ids, files: files };
  }

  function slideMatchesHide(slide, targets) {
    if (!slide) return false;
    if (slide.classList.contains('t4s-product__media-item--variant')) return true;
    var mid = slide.getAttribute('data-media-id');
    if (mid && targets.ids[String(mid)]) return true;
    var img = slide.querySelector('img[data-master], img[data-src], img');
    if (!img) return false;
    var src = img.getAttribute('data-master') || img.getAttribute('data-src') || img.getAttribute('src') || '';
    var fk = fileKey(src);
    if (fk && targets.files[fk]) return true;
    // leftover format previews not (yet) attached to a variant
    if (fk.indexOf('art_format') === 0) return true;
    return false;
  }

  function getFlickity(gallery) {
    if (!gallery) return null;
    if (gallery.flickityt4s) return gallery.flickityt4s;
    if (window.Flickityt4s && typeof window.Flickityt4s.data === 'function') {
      try {
        return window.Flickityt4s.data(gallery);
      } catch (e) {}
    }
    if (window.Flickity && typeof window.Flickity.data === 'function') {
      try {
        return window.Flickity.data(gallery);
      } catch (e) {}
    }
    return null;
  }

  function markHidden(el) {
    if (!el) return false;
    var changed = !el.classList.contains('is--media-hide');
    el.classList.add('is--media-hide');
    el.setAttribute('data-ans-ctor-format-media', '1');
    el.style.setProperty('display', 'none', 'important');
    return changed;
  }

  function thumbMatchesHide(thumb, targets) {
    if (!thumb) return false;
    var img = thumb.querySelector('img[data-master], img[data-src], img');
    if (!img) return false;
    var src = img.getAttribute('data-master') || img.getAttribute('data-src') || img.getAttribute('src') || '';
    var fk = fileKey(src);
    if (fk && targets.files[fk]) return true;
    if (fk.indexOf('art_format') === 0) return true;
    return false;
  }

  function hideFormatGalleryMedia(root, product) {
    var targets = collectHideTargets(product);
    var slides = root.querySelectorAll('[data-main-slide][data-media-id]');
    var changed = false;
    var firstVisible = null;
    for (var i = 0; i < slides.length; i++) {
      var slide = slides[i];
      if (slideMatchesHide(slide, targets)) {
        if (markHidden(slide)) changed = true;
      } else if (!firstVisible) {
        firstVisible = slide;
      }
    }

    // Kalles thumb strip is separate from main slides — hide matching nav items too
    var thumbs = root.querySelectorAll(
      '.t4s-carousel__nav-item, .t4s-product__thumb-item, .ans-pdp-thumbs .t4s-col-item'
    );
    for (var t = 0; t < thumbs.length; t++) {
      if (thumbMatchesHide(thumbs[t], targets)) {
        if (markHidden(thumbs[t])) changed = true;
      }
    }

    var galleries = root.querySelectorAll('[data-main-media]');
    for (var g = 0; g < galleries.length; g++) {
      var flkty = getFlickity(galleries[g]);
      if (!flkty) continue;
      try {
        if (typeof flkty.reloadCells === 'function') flkty.reloadCells();
        if (typeof flkty.resize === 'function') flkty.resize();
        var sel = firstVisible;
        if (sel && typeof flkty.selectCell === 'function') {
          flkty.selectCell(sel, false, true);
        } else if (sel && typeof flkty.select === 'function') {
          var cells = flkty.getCellElements
            ? flkty.getCellElements()
            : (flkty.cells || []).map(function (c) {
                return c.element;
              });
          var idx = cells ? Array.prototype.indexOf.call(cells, sel) : -1;
          if (idx < 0) {
            for (var c = 0; c < (cells || []).length; c++) {
              if (cells[c] && !cells[c].classList.contains('is--media-hide')) {
                idx = c;
                break;
              }
            }
          }
          if (idx >= 0) flkty.select(idx, false, true);
        }
      } catch (e) {}
    }
    return changed;
  }

  function init(root, product) {
    if (root.getAttribute(ROOT_ATTR)) return;
    root.setAttribute(ROOT_ATTR, '1');
    root.classList.add('ans-ctor-variants');

    var form = getForm(root);
    if (!form) return;

    var byFormat = buildMaps(product.variants || []);
    var formatWrap = optionWrap(form, '0');
    if (!formatWrap) return;

    var applying = false;
    var refreshing = false;

    function safeRefresh() {
      if (refreshing) return;
      refreshing = true;
      refreshUi(form, byFormat);
      hideFormatGalleryMedia(root, product);
      refreshing = false;
    }

    function applyFormat(format, preferredSize) {
      var row = pickVariantForFormat(byFormat, format, preferredSize);
      if (!row) return;
      applying = true;
      syncRadios(form, format, row.size, row.depth);
      setVariantSelect(form, row.id);
      safeRefresh();
      applying = false;
    }

    // Capture clicks on format swatches before / instead of broken linked-option path
    formatWrap.addEventListener(
      'click',
      function (ev) {
        var label = ev.target.closest('label[data-swatch-item]');
        if (!label || !formatWrap.contains(label)) return;
        var format = label.getAttribute('data-value');
        if (!format || !byFormat[format]) return;

        var sizeWrap = optionWrap(form, '1');
        var sizeChecked = sizeWrap
          ? sizeWrap.querySelector('input.t4s-swatch-input:checked')
          : null;
        var preferred = sizeChecked ? sizeChecked.value : '';

        ev.preventDefault();
        ev.stopPropagation();
        applyFormat(format, preferred);
      },
      true
    );

    // After Kalles updates soldout classes, re-apply our filter
    var select = form.querySelector('select[name="id"], select.t4s-product__select');
    if (select) {
      select.addEventListener('change', function () {
        requestAnimationFrame(safeRefresh);
      });
    }

    var mo = new MutationObserver(function () {
      if (applying || refreshing) return;
      requestAnimationFrame(safeRefresh);
    });
    mo.observe(form, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    // Keep format media hidden if theme toggles gallery classes on variant change
    var galleryRoot = root.querySelector('[data-product-single-media-group]') || root;
    var galMo = new MutationObserver(function () {
      if (applying || refreshing) return;
      requestAnimationFrame(function () {
        hideFormatGalleryMedia(root, product);
      });
    });
    galMo.observe(galleryRoot, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    safeRefresh();
    // Flickity often inits after defer scripts
    setTimeout(function () {
      hideFormatGalleryMedia(root, product);
    }, 400);
    setTimeout(function () {
      hideFormatGalleryMedia(root, product);
    }, 1200);
  }

  ready(function () {
    var root = findRoot();
    if (!root) return;

    fetch('/products/' + HANDLE + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('product.js ' + r.status);
        return r.json();
      })
      .then(function (product) {
        init(root, product);
      })
      .catch(function () {
        /* silent — PDP still works with theme defaults */
      });
  });
})();
